import React, { type PropsWithChildren } from "react";
import { Box, Flex, type SpaceProps } from "@chakra-ui/react";
import { DecorativeBackgroundImage } from "components/images";
import greenBg from "../../../public/assets/cards/aura-bg-green.png";
import greenBgMobile from "../../../public/assets/cards/aura-bg-mobile-green.png";
import blueBg from "../../../public/assets/cards/aura-bg-blue.png";
import blueBgMobile from "../../../public/assets/cards/aura-bg-mobile-blue.png";

export type AuraCardProps = {
  /**
   * The color variant to use for the aura background.
   *
   * @default "green"
   * */
  variant?: "green" | "blue";
};

/**
 * A green-toned card with a static, bottom-centered aura background that fills the card.
 */
export function AuraCard({
  variant = "green",
  children,
  ...spaceProps
}: PropsWithChildren<AuraCardProps & SpaceProps>) {
  return (
    <Box
      pos="relative"
      borderRadius={{ base: "big", sm: "bigger" }}
      px={{ base: "big", md: "biggest", xl: "huge" }}
      py={{ base: "biggest", sm: "huge", xl: "huger" }}
      bg="brand.backgroundSecondary.light"
      color={`new.${variant}.900`}
      overflow="hidden"
      {...spaceProps}
    >
      <BgImage variant={variant} />
      <Box pos="relative">{children}</Box>
    </Box>
  );
}

function BgImage({ variant }: AuraCardProps) {
  let bg = greenBg;
  let bgMobile = greenBgMobile;

  if (variant === "blue") {
    bg = blueBg;
    bgMobile = blueBgMobile;
  }

  return (
    <Flex aria-hidden="true" pos="absolute" boxSize="100%" inset={0}>
      <Box display={{ base: "none", md: "inline-block" }} pos="relative" boxSize="100%" userSelect="none">
        <DecorativeBackgroundImage src={bg} style={{ objectFit: "cover", objectPosition: "center bottom" }} />
      </Box>
      <Box display={{ base: "inline-block", md: "none" }} pos="relative" boxSize="100%" userSelect="none">
        <DecorativeBackgroundImage src={bgMobile} style={{ objectFit: "cover", objectPosition: "center bottom" }} />
      </Box>
    </Flex>
  );
}
